import React from 'react'

import { FormOnChange, Select } from '@procsea/design-system'

import useCountryOptions from './useCountryOptions'

export interface CountrySelectorProps {
  'data-e2e'?: string
  disabled?: boolean
  errorMessage?: string
  onChange?: FormOnChange<string | null>
  value?: string | null
  required?: boolean
}

const CountrySelector = ({
  'data-e2e': dataE2e = 'country-select',
  disabled = false,
  errorMessage,
  onChange,
  value,
  required,
}: CountrySelectorProps) => {
  const countriesSelectOptions = useCountryOptions()

  return (
    <Select<string, false>
      data-e2e={dataE2e}
      disabled={disabled}
      errorMessage={errorMessage}
      label={gettext('Country')}
      onChange={onChange}
      options={countriesSelectOptions}
      placeholder={gettext('Select a country')}
      required={required}
      value={value}
    />
  )
}

export default CountrySelector
